/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
// import LayoutOperation from "../../components/layout_operation";
// import { DownOutlined, MenuOutlined, UploadOutlined } from "@ant-design/icons";
// import reqwest from "reqwest";
// import { AddUser } from "../../actions/taskAction";
// import { connect } from "react-redux";
// import moment from "moment";
// import { Api, Ui } from "../../services";
// import axios from "axios";
import Cookies from "js-cookie";
import { Redirect } from "react-router-dom";
import { Modal } from "antd";
import ServiceApi from "../../services/ServiceApi";

class Login extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      form: {},
      userToken: "",
      redirect: 0,
      redirectPath: "",
      modal: null,
      errorDetail: "",
      submitting: 0,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  CookiesChecker() {
    let redirectpath = !this.props.location
      .state /*|| (this.props.location.state.frompage) === '/MaxiOperation/login' */
      ? "/MaxiOperation/"
      : this.props.location.state.frompage;
    const moduleToken = Cookies.get("OperationToken");
    let identifier = {};
    if (moduleToken) {
      try {
        identifier = ServiceApi.post("tokenchecker", {
          TokenUser: moduleToken,
        });
      } catch (error) {
        identifier = error;
      }
      identifier.then((value) => {
        if (value.data.result.value === "P") {
          console.log("cookies pass");
          this.setState({
            redirectPath:
              redirectpath === "/" ? "/Maxioperation/" : redirectpath,
            redirect: this.props.location.pathname === "/" ? 1 : 0,
          });
        } else {
          this.setState({
            redirectPath: "/",
            redirect: this.props.location.pathname === "/" ? 0 : 1,
          });
        }
      });
    } else {
      this.setState({
        redirectPath: "/",
        redirect: this.props.location.pathname === "/" ? 0 : 1,
      });
    }
  }
  renderRedirect = () => {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: this.state.redirectPath,
            state: { frompage: this.props.location.pathname },
          }}
        />
      );
    }
  };
  componentWillMount() {
    document.title = "MaxiOperation - Login";
    // this.CookiesChecker();
    // const data_from_dynamic = await Api.Get(
    //   "get_list_mas_form_json",
    //   "oper_job"
    // );
    // const period = await Api.Post("get_ma_period", {
    //   pk_id: "",
    //   is_active: "1",
    //   effective: "",
    //   sql_where: "",
    // });
    // const asset = await Api.Get("get_cdi_new_smart");
    // const job_cat_obj = await Api.Get("get_job_category");
    // const getBtn = await Api.Post("getButtonDetailWeb", {
    //   WF_ID: 0,
    //   CompanyID: 1,
    //   ProjectID: 1,
    //   JobTypeID: 1,
    //   Version: 1,
    //   MainProcessID: "0",
    //   SubProcessID: "-1",
    //   ActionID: 1,
    //   UserName: "tirapong_s",
    //   TokenUser: "63423fe4c6ff56e7e9b4fcb0c50cb3f386316931"
    // }, );
  }
  handleInputChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;
    if (name === "username") {
      form["UserName"] = value;
    }
    if (name === "password") {
      form["Password"] = value;
    }
  }

  toJson(jsonString) {
    let myJSONString = JSON.parse(JSON.stringify(jsonString.data.data));
    return JSON.parse(myJSONString);
  }

  handleSubmit = () => {
    this.setState({
      submitting: 1,
      errorDetail: null,
    });
    const authentication = this.authen().then((value) => {
      console.log("authentication val :");
      console.log(value);
      if (value.data.result.value === "P") {
        Cookies.set("OperationToken", value.data.data[0].token, { expires: 1 });
        Cookies.set("userId", value.data.data[0].id, { expires: 1 });
        Cookies.set("username", this.state.form.UserName, { expires: 1 });
        Cookies.set("companyid", value.data.data[0].company_id, { expires: 1 });
        Cookies.set("team_id", value.data.data[0].team_id, { expires: 1 });
        Cookies.set("usergroup_id", value.data.data[0].usergroup_id, {
          expires: 1,
        });
        Cookies.set("project_id", value.data.data[0].project_id, {
          expires: 1,
        });

        this.setState({
          modal: 1,
        });
        setTimeout(() => {
          //this.CookiesChecker();
          window.location.assign("/MaxiOperation/");
          this.setState({ modal: 0 });
        }, 2000);
      } else {
        this.setState({
          modal: 1,
          errorDetail: "Please Check Username And Password !!! ",
        });
      }
      this.setState({
        submitting: 0,
      });
    });
  };
  isSubmit = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };
  modalClosed = () => {
    this.setState({
      modal: 0,
    });
  };
  authen = async () => {
    try {
      const success = await ServiceApi.post("maxilogin", {
        UserName: this.state.form.UserName,
        Password: this.state.form.Password,
        CompanyID: "",
      });
      return success;
    } catch (error) {
      return error;
    }
  };

  render() {
    const { data } = this.state;
    return (
      <div className="container body-content">
        {this.renderRedirect()}
        <Modal
          title={null}
          centered
          visible={this.state.modal}
          footer={null}
          closable={this.state.errorDetail ? true : false}
          maskClosable={this.state.errorDetail ? true : false}
          onCancel={this.modalClosed}
        >
          <div className="text-center">
            {!this.state.errorDetail ? (
              <img
                src={ServiceApi.absoluteUrl("/img/modal_approve.svg")}
                className="img-fluid"
              />
            ) : (
              <img
                src={ServiceApi.absoluteUrl("/img/login_error.png")}
                className="img-fluid"
              />
            )}

            <h3
              className={
                "font-mont-sb fs-18 mt-3" +
                (!this.state.errorDetail ? " c-blue" : " c-red")
              }
            >
              {!this.state.errorDetail ? "Successfully Login" : "Failed"}
            </h3>
            {this.state.errorDetail ? (
              <Fragment>{this.state.errorDetail}</Fragment>
            ) : (
              <Fragment>
                redirecting{" "}
                <div
                  className="spinner-border position-relative"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    left: "0.5rem",
                    top: "0.5rem",
                    zIndex: 1001,
                  }}
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </Fragment>
            )}
          </div>
        </Modal>
        <div className="background-100"></div>

        <div className="box-container">
          <div>
            <select defaultValue="EN" className="form-control chang-lgg">
              <option value="EN">EN</option>
              <option value="TH">TH</option>
            </select>
          </div>
          <div className="row">
            <div className="col-6 offset-md-1 mt-form-log">
              <div>
                <img src={ServiceApi.absoluteUrl("/img/Group_278.png")} />
              </div>

              <div className="row" style={{ marginTop: "45px" }}>
                <div className="col-auto">
                  <div className="form-group">
                    <label
                      className="la-login-user f-mon"
                      style={{
                        fontSize: "12px",
                        margin: "0px",
                        color: " #333333",
                      }}
                    >
                      Username
                    </label>
                    <input
                      className="form-input-maxi in-login-user f-mon"
                      data-val="true"
                      placeholder="Please enter your username"
                      required="required"
                      style={{
                        backgroundColor: "#d9e4fc",
                        fontSize: "12px",
                        height: "40px",
                        width: "290px",
                      }}
                      type="text"
                      name="username"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div
                    className="form-group"
                    style={{ marginTop: "5px !important", marginBottom: "5px" }}
                  >
                    <label
                      className="la-login-pw f-mon"
                      htmlFor="Password"
                      style={{
                        fontSize: "12px",
                        margin: "0px",
                        color: " #333333",
                      }}
                    >
                      Password
                    </label>
                    <input
                      className="form-input-maxi in-login-pw f-mon"
                      placeholder="Please enter your password"
                      required="required"
                      style={{
                        backgroundColor: "#d9e4fc",
                        fontSize: "12px",
                        height: "40px",
                        width: "290px",
                      }}
                      type="password"
                      name="password"
                      onChange={this.handleInputChange}
                      onKeyUp={this.isSubmit}
                    />
                  </div>

                  <div
                    className="row justify-content-center"
                    style={{ marginTop: "30px" }}
                  >
                    <button
                      className="btn btn-block btn-login font-mon login-page"
                      style={
                        this.state.submitting === 0
                          ? {}
                          : { cursor: "not-allowed" }
                      }
                      disabled={this.state.submitting === 0 ? false : true}
                      onClick={this.handleSubmit}
                    >
                      {this.state.submitting === 0 ? (
                        "LogIn"
                      ) : (
                        <div
                          className="spinner-border position-relative"
                          style={{
                            width: "2rem",
                            height: "2rem",
                            color: "#fff",
                            zIndex: 1001,
                          }}
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </button>
                  </div>

                  <div className="row">
                    <div
                      className="f-mon alarm-login"
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginTop: "10px",
                        padding: "15px",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-5" style={{ paddingRight: "0px" }}>
              <div className="d-flex flex-row-reverse" align="right">
                <div
                  className="login-image"
                  style={{ marginBottom: "-1px" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
